import { useState, useEffect } from 'react';
import { tokensApi } from '../lib/api';

const GRANT_STORAGE_KEY = (userId: string) => `emss_last_grant_${userId}`;

interface GrantData {
  amount: number;
  createdAt: string;
}

/**
 * Detecta o crédito de teste mais recente (`admin_grant`) do piloto logado.
 * Espelha o padrão de useTierPromotion: marca no localStorage para exibir o
 * modal "Você recebeu Marbles" uma única vez por crédito.
 */
export function useMarblesGrant(emssUser: any) {
  const [grantData, setGrantData] = useState<GrantData | null>(null);

  useEffect(() => {
    if (!emssUser?.id) return;

    let isMounted = true;

    const checkGrant = async () => {
      try {
        const history = (await tokensApi.history(50, 0)) as any[];
        const grants = (Array.isArray(history) ? history : [])
          .filter((tx: any) => tx?.event_type === 'admin_grant')
          .sort((a: any, b: any) =>
            new Date(b.created_at).getTime() - new Date(a.created_at).getTime(),
          );
        const latest = grants[0];
        if (!latest?.created_at) return;

        const storageKey = GRANT_STORAGE_KEY(emssUser.id);
        const lastSeen = localStorage.getItem(storageKey);

        if (lastSeen && new Date(latest.created_at).getTime() <= new Date(lastSeen).getTime()) {
          return;
        }

        if (isMounted) {
          setGrantData({
            amount: Math.abs(Number(latest.amount) || 0),
            createdAt: latest.created_at,
          });
        }
        localStorage.setItem(storageKey, latest.created_at);
      } catch {
        // Silenciosamente ignora falhas não-críticas (padrão useTierPromotion)
      }
    };

    checkGrant();

    return () => {
      isMounted = false;
    };
  }, [emssUser?.id]);

  const clearGrant = () => setGrantData(null);

  return { grantData, clearGrant };
}
